import { ReactNode } from 'react';
import { SplitFactoryProvider } from '@splitsoftware/splitio-react';
import { NotificationProvider } from '@utils/notification/notification';
import { TopBannerProvider } from './top-banner';
import { ErrorOverlay, ErrorTestOverlay } from '@fractions/error';
import { ErrorBoundary } from '../error-boundary';
import { AuthProvider } from '../auth';
import { OrganizationProvider } from './organization';
import { SubscriptionProvider } from './subscription';
import { apolloClient } from '../apollo-client';
import { isDevelopment } from '@utils/environment';
import { config } from '@config';

const splitSdkConfig = {
    core: {
        authorizationKey: config.splitioApiKey,
        key: 'default-user-id',
    },
};

export function AppProviders({ children }: { children: ReactNode }) {
    return (
        <SplitFactoryProvider config={splitSdkConfig}>
            <NotificationProvider>
                <TopBannerProvider>
                    <ErrorOverlay />
                    {isDevelopment() && <ErrorTestOverlay />}
                    <ErrorBoundary>
                        <AuthProvider apolloClient={apolloClient}>
                            <OrganizationProvider>
                                <SubscriptionProvider>{children}</SubscriptionProvider>
                            </OrganizationProvider>
                        </AuthProvider>
                    </ErrorBoundary>
                </TopBannerProvider>
            </NotificationProvider>
        </SplitFactoryProvider>
    );
}
